import { SettingsButtonContainer } from '@desktop/components/editors/CommonSettingsStyles';
import PasswordResetDialog from '@desktop/components/editors/other/PasswordReset';
import Button from '@shared/components/core/button/CoreButton';
import CommonRow from '@shared/components/core/row/CommonRow';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function PasswordResetSection() {
    const { t } = useTranslation();
    const [openDialog, setOpenDialog] = useState(false);

    const handleOpenDialog = () => setOpenDialog(true);
    const handleCloseDialog = () => setOpenDialog(false);

    return (
        <>
            <CommonRow
                title={t('common:account.password.change')}
                description={t('common:account.password.description')}>
                <SettingsButtonContainer>
                    <Button $size="xsmall" $color="secondary" startIcon="sync" onClick={handleOpenDialog}>
                        {t('common:update')}
                    </Button>
                </SettingsButtonContainer>
            </CommonRow>

            <PasswordResetDialog open={openDialog} onClose={handleCloseDialog} />
        </>
    );
}
